import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import zpindex from "@/views/zpindex.vue"

export const constantRoutes = [

    // {
    //     path: '/',
    //     component: Layout,
    //     redirect: '/zpindex',
    //     children: [{
    //         path: 'zpindex',
    //         name: 'zpindex',
    //         component: () => import("@/views/zpindex/index"),
    //         meta: {title: 'zpindex', icon: 'dashboard'}
    //     }]
    // },
    {
        path: '/',
        redirect: '/zpindex',

    },
    {
        path: '/zpindex',
        component: zpindex,
        meta: {title: 'zpindex', icon: 'dashboard'}
    },
    {
        path: '/shzp',
        component: Layout,
        children: [{
            path: '/shzp',
            name: 'shzp',
            component: () => import('@/views/shzp.vue'),
            meta: {title: 'shzp', icon: 'dashboard'}
        }, {
            path: '/sqzw',
            name: 'sqzw',
            component: () => import('@/views/shengqin.vue'),
            meta: {title: 'sqzw', icon: 'dashboard'}
        }]
    },
    // {
    //     path: '/sqzw',
    //     component: Layout,
    //     children: [{
    //         path: '/sqzw',
    //         name: 'sqzw',
    //         component: () => import('@/views/shengqin.vue'),
    //         meta: {title: 'sqzw', icon: 'dashboard'}
    //     }]
    // },


]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: (to, from, savedPosition) => {
        // 
        // 
        // 
        return {
            y: 0
        }
    },
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
